module.exports = __webpack_public_path__ + "static/media/law-clerk.00515950.jpg";